import React, { useEffect } from "react";
import useStatus from "../../../../common-deprecated/hooks/useStatus";
import { useCompareV2Selector } from "../../redux/store";
import useInitNewCompare from "../../hooks/useInitNewCompare";
import AEMToyotaCompareView from "./CompareV2View";
import useNcCompareTools from "../../hooks/useNcCompareTools";
import { aemToyotaCompareModalMap } from "./modals/modals";
import { useModalMap } from "../../../../common-deprecated/containers/ModalProvider";
import { setNcCompareTrackingContext, updateTrackingLayerVersioning } from "../../utils/tracking";

const CompareToyota = (): JSX.Element => {
    const commonSettings = useCompareV2Selector((state) => state.commonSettings);
    const ncCompareContext = useCompareV2Selector((state) => state.newCarCompare.ncCompareContext);

    useInitNewCompare();
    useModalMap(aemToyotaCompareModalMap);
    const tools = useNcCompareTools();
    useStatus(commonSettings, "Compare V2", tools);

    useEffect(() => {
        setNcCompareTrackingContext(ncCompareContext);
        updateTrackingLayerVersioning();
    }, []);

    return <AEMToyotaCompareView />;
};

export default CompareToyota;
